import ApiConstants from '../../constants/ApiConstants';
import xhr from './xhr';

const TutorScheduleApiUtils = {
  fetchDataForSchedulesCal(id, startTime) {
    let query = '?startTime=' + new Date(startTime).getTime();
    return xhr(
      ApiConstants.Base +
        'tutors/' +
        id +
        '/settings/data-for-schedules-cal' +
        query,
    );
  },
  createMany(tutorId, params = {}) {
    return xhr(
      ApiConstants.Base + 'tutors/' + tutorId + '/settings/schedules',
      {
        method: 'post',
        body: JSON.stringify({
          start_time: params.startTime,
          add_type_schedules: params.newAddTypeSchedules,
          remove_type_schedules: params.newRemoveTypeSchedules,
        }),
      },
    );
  },
};

export default TutorScheduleApiUtils;
